import { useContext } from 'react';
import AuthContext from '../../contexts/AuthContext';

export interface ChatIdentity {
  userId: string | null;
  fullName: string | null;
  avatarUrl: string | null;
  variant: 'learner' | 'admin' | null;
}

/**
 * Returns the current viewer's identity for chat purposes from the unified
 * auth context. With a single app there is no longer a learner/admin split at
 * the identity level — every member resolves through `AuthProvider`.
 */
export function useCurrentChatIdentity(): ChatIdentity {
  const auth = useContext(AuthContext);

  // Backend stores ULIDs uppercase; normalise here so string comparisons
  // against member.user_id / message.sender_id are stable regardless of
  // what was previously cached in sessionStorage / localStorage.
  const norm = (id: string | null | undefined): string | null =>
    id ? id.toUpperCase() : null;

  if (auth?.isAuthenticated && auth.user) {
    return {
      userId: norm(auth.user.id),
      fullName: auth.user.full_name ?? null,
      avatarUrl: auth.user.avatar_url ?? null,
      variant: 'admin',
    };
  }
  return { userId: null, fullName: null, avatarUrl: null, variant: null };
}
